import uuid from 'uuid/v4';

import {
    PUSH_NOTIFICATION_TO_STACK,
    POP_NOTIFICATION_FROM_STACK,
    FLUSH_NOTIFICATION_FROM_STACK,
} from './constants';

export const pushNotificationToStack = (message) => {
    const id = uuid();
    return {
        type: PUSH_NOTIFICATION_TO_STACK,
        payload: {
            [id]: {
                message,
                id,
            },
        },
    };
};

export const popNotificationFromStack = (notificationId) => ({
    type: POP_NOTIFICATION_FROM_STACK,
    payload: notificationId,
});

export const flushNotificationsFromStack = () => ({
    type: FLUSH_NOTIFICATION_FROM_STACK,
});
